import axios from 'axios';

const BASE_URL = 'https://mototaksi.az:9999/api/v6/lotoreya';

const LotoreyaController = {
  // Bütün lotoreyaları gətir
  getAllLotoreyas: async () => {
    try {
      const response = await axios.get(BASE_URL);
      return response.data;
    } catch (error) {
      console.error('Lotoreyalar alınarkən xəta:', error);
      throw error;
    }
  },

  // ID-yə görə lotoreya gətir
  getLotoreyaById: async (lotoreyaId) => {
    try {
      const response = await axios.get(`${BASE_URL}/${lotoreyaId}`);
      return response.data;
    } catch (error) {
      console.error(`ID ${lotoreyaId} üçün lotoreya alınarkən xəta:`, error);
      throw error;
    }
  },

  // Yeni lotoreya yarat
  createLotoreya: async (lotoreyaData) => {
    try {
      const response = await axios.post(BASE_URL, lotoreyaData);
      return response.data;
    } catch (error) {
      console.error('Lotoreya yaradılarkən xəta:', error);
      throw error;
    }
  },

  // Lotoreyanı yenilə
  updateLotoreya: async (lotoreyaId, lotoreyaData) => {
    try {
      const response = await axios.put(`${BASE_URL}/${lotoreyaId}`, lotoreyaData);
      return response.data;
    } catch (error) {
      console.error(`Lotoreya ID ${lotoreyaId} yenilənərkən xəta:`, error);
      throw error;
    }
  },

  // Lotoreyanı sil
  deleteLotoreyaById: async (lotoreyaId) => {
    try {
      const response = await axios.delete(`${BASE_URL}/${lotoreyaId}`);
      return response.data;
    } catch (error) {
      console.error(`Lotoreya ID ${lotoreyaId} silinərkən xəta:`, error);
      throw error;
    }
  },

  // İstifadəçiyə aid lotoreyaları gətir (əgər backend endpoint varsa)
  getLotoreyasByUserId: async (userId) => {
    try {
      const all = await LotoreyaController.getAllLotoreyas();
      return all.filter(l => l.userId === parseInt(userId));
    } catch (error) {
      console.error(`User ID ${userId} üçün lotoreyalar alınarkən xəta:`, error);
      throw error;
    }
  }
};

export default LotoreyaController;
